"use client";

import React, { useEffect, useRef } from "react";
import TextCarousel from "../ui/textCarousel";
import TiktokSlider from "../slider/tiktokSlider";
import RevealElement from "../revealElement";
import BottomCurves from "../curves/bottomCurves";
import FloatingArrow from "../uiDecor/floatingArrow";

import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function NestedSlider({ data }: any) {
  const emojiOne = useRef<HTMLImageElement>(null);
  const emojiTwo = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const emojiTL = gsap.timeline({
      scrollTrigger: {
        trigger: document.querySelector(".nestedSlider"),
        start: "bottom bottom",
        end: "bottom top",
        scrub: 1.3,
        markers: false,
      },
    });

    emojiTL.to(emojiOne.current, { yPercent: -10 }).to(emojiTwo.current, { yPercent: -20 }, "<");

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 1500);
  }, [data]);

  return (
    <section className="pt-20 pb-32 px-0 bg-purpleTurquoise nestedSlider">
      <RevealElement>
        <TextCarousel text={data.heading} color={""} colouredPosition={0} />
      </RevealElement>

      <div className="mt-32 pb-[12.5vw]">
        <TiktokSlider slides={data.slides} />
      </div>

      <BottomCurves direction="right" color={data.waveBgColor?.waveBgColor} />

      <FloatingArrow direction="right" className="top-0 right-[10.625vw]" wrapText="our-work"/>
    </section>
  );
}
